// Generated by barrles.ps1

export * from "./app-layout.component";
